import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageToggle';

import {PrivacyPageDe, PrivacyPageEn} from './PrivacyPage';
import {TermsPageDe, TermsPageEn} from './TermsPage';
import {ImpressumPageDe, ImpressumPageEn} from './ImpressumPage';
import {RefundPageDe, RefundPageEn} from './RefundPage';
import {ContactPageDe, ContactPageEn} from './ContactPage';
import {AboutPageDe, AboutPageEn} from './AboutPage';

import { trackEngagementEvents } from '../../utils/ga4Events';

// Base component for all pages
const LocalizedPage = ({ children }) => {
  const { language } = useContext(LanguageContext);
  return children({ language });
};

const Contact = () => {
  trackEngagementEvents.contactViewed();
  return (
    <LocalizedPage>
      {({ language }) => (
        language === 'en' ? <ContactPageEn /> : <ContactPageDe />
      )}
    </LocalizedPage>
  );
};

const Refund = () => {
  trackEngagementEvents.refundViewed();
  return (
    <LocalizedPage>
      {({ language }) => (
        language === 'en' ? <RefundPageEn /> : <RefundPageDe />
      )}
    </LocalizedPage>
  );
};

const Privacy = () => {
  trackEngagementEvents.privacyViewed();
  return (
    <LocalizedPage>
      {({ language }) => (
        language === 'en' ? <PrivacyPageEn /> : <PrivacyPageDe />
      )}
    </LocalizedPage>
  );
};

const Terms = () => {
  trackEngagementEvents.termsViewed();
  return (
    <LocalizedPage>
      {({ language }) => (
        language === 'en' ? <TermsPageEn /> : <TermsPageDe />
      )}
    </LocalizedPage>
  );
};

const Impressum = () => {
  trackEngagementEvents.impressumViewed();
  return (
    <LocalizedPage>
    {({ language }) => (
      language === 'en' ? <ImpressumPageEn /> : <ImpressumPageDe />
    )}
  </LocalizedPage>
  );
};

const About = () => {
  trackEngagementEvents.aboutViewed();
  return (
    <LocalizedPage>
      {({ language }) => (
        language === 'en' ? <AboutPageEn /> : <AboutPageDe />
      )}
    </LocalizedPage>
  );
};

export { Contact, Refund, Privacy, Terms, Impressum, About };